import BaseAPI from '../base'

function getGroups(cafe_id) {
    return BaseAPI.get(`promocodes/groups/list/${cafe_id}`);
}

function create(data) {
    return BaseAPI.post(`promocodes/groups/create`, data);
}

function remove(id) {
    return BaseAPI.post(`promocodes/groups/remove/${id}`);
}

function getInfo(id) {
    return BaseAPI.get(`promocodes/groups/info/${id}`);
}

export default {
    getGroups,
    create,
    remove,
    getInfo
}